
// property: show-title-in-authoring-bar
// type: integer
// defaultValue: 85
// description: show the solution title in authoring.
// description: limit to the 85 first characters. setting to 0 means no title displayed 

// property: show-results-sort-selector
// type: boolean
// defaultValue: true
// description: Show/Hide the sort by title / best match selector in results list 

// property: show-similarity
// type: boolean
// defaultValue: false
// description: display the similarity in the results

// property: show-similarity-image
// type: string
// defaultValue: false
// description: values are false, bar, stars 

// property: show-value-score
// type: boolean
// defaultValue: true

// property: show-more-values
// type: boolean
// defaultValue: true
// description: Hide the show more values button in guide 

// property: show-chat-style
// type: boolean
// defaultValue: true
// description: Displays the chat bot style when this property is true or not defined else display the guide classic layout 

// property: show-viewed-icon
// type: boolean
// defaultValue: true
// description: Hide/show viewed icon for results when not in a diagnostic session 

// property: handle-mandatory-att
// type: boolean
// defaultValue: false
// description: Only display the solutions if an mandatory attribute has been answered 

// property: handle-mandatory
// type: boolean
// defaultValue: false

// property: handle-external-source
// type: boolean
// defaultValue: false
// description: Handle the external sources that can be displayed with the results 

// property: show-external-results
// type: boolean
// defaultValue: true
// description: Displays the external results tab when this property is true or not defined 

// property: ds-product-att
// type: string
// defaultValue: APPLIANCE_MODEL
// description: DS attributes

// property: ds-product-sn
// type: string
// defaultValue: SERIAL_NUMBER
// description: DS serial number

// property: ds-search-tab
// type: string
// defaultValue: DIALOG
// description: Tab name used for the DS Search 

// property: dsEnabled
// type: boolean
// defaultValue: true
// description: Enable Service Session on Call Center UI 

// property: exit-ds-on-home-link
// type: boolean
// defaultValue: true
// description: Clicking the home link exits the current Service Session 

// property: handle-auto-switch-to-workgroups-on-ds-search
// type: boolean
// defaultValue: false
// description: Automatically switch to My Workgroups/All workgroups tab on DS search 

// property: max-solutions-in-pdf
// type: integer
// defaultValue: 100
// description: Maximum number of solutions that can be printed on the result page

// property: show-author-detail-preview
// type: boolean
// defaultValue: false
// description: Do not enable this property; this feature is not supported. 

// property: exclude-slots-from-sort-selector
// type: string
// defaultValue: SLOT_NAME1,SLOT_NAME2,...
// description: attributes that need to be excluded from the sort list
// description:  value: templateName/slotName of the attributes separated by a comma(,) without any space

// property: show-share-mail
// type: boolean
// defaultValue: true
// description: enable/disable the sharing of solution using mail

// property: show-share-twitter
// type: boolean
// defaultValue: true
// description: enable/disable the sharing of solution using twitter

// property: show-share-stumbleupon
// type: boolean
// defaultValue: true
// description: enable/disable the sharing of solution using stumbleupon

// property: show-share-delicius
// type: boolean
// defaultValue: true
// description: enable/disable the sharing of solution using delicius

// property: show-share-facebook
// type: boolean
// defaultValue: true
// description: enable/disable the sharing of solution using facebook

// property: show-share-linkedin
// type: boolean
// defaultValue: true
// description: enable/disable the sharing of solution using linkedin

// property: show-crm-feedback-on-search-completed
// type: boolean
// defaultValue: true
// description: show/hide crm feedback on search completion, if there is CRM integration

// property: crm-feedback-menu-during-all-session
// type: boolean
// defaultValue: true
// description: If there is CRM integration, display the CRM menu during all the session (true) or only for the first search (false) until reset 

// property: show-dialog-nomatch-popup
// type: boolean
// defaultValue: false
// description: enable/disable the popup after a free text search if the search no match 

// property: showBookmark
// type: boolean
// defaultValue: true
// description: enable/disable the bookmark link

// property: timeout-grace-period
// type: integer
// defaultValue: 900
// description: grace period to show the timout warning (in seconds) 

// property: disable-formsubmit-when-pressing-enter
// type: string
// defaultValue: ja ko
// description: disable form submit when pressing enter for the locales 

// property: handle-confirm-status-message
// type: boolean
// defaultValue: true
// description: enable/disable the confirm message after changing the status of a solution 

// property: handle-confirm-status-notification-type
// type: string
// defaultValue: top
// description: provides the type of confirm status message , in case its value is 'top' it displays 
// description: auto-fade notification at the top ,otherwise displays notification as 'popup'

// property: show-help-sticky
// type: boolean
// defaultValue: false
// description: make the help property sticky or not on mouseover 

// property: case-name-format
// type: string
// defaultValue: k\d{8}$  
// description: regular expression which match the Solution Number format 

// property: same-origin-frame
// type: boolean
// defaultValue: true
// description: enable/disable the X-Frame-Options HTTP response header SAMEORIGIN value 

// property: content-security-policy-self
// type: boolean
// defaultValue: true
// description: enable/disable the Content-Security-Policy HTTP response header frame-ancestors 'self' value 

// property: transitions-from-authoring-data-only
// type: boolean
// defaultValue: false
// description: enable/disable to loose/tight the approval transition for the case 

class SkinProperties {

    get(properties, property, defaultValue) {
        if (properties[property] == null)
            return defaultValue;
        return properties[property];
    }
}

export default new SkinProperties;